<template>
  <div class="modal fade" :id="id" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("projectTypes.stepModalTitle") }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText :text="$t('projectTypes.dragToReorder')" />

            <Card  class="card my-5 p-5">
              <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="step-datatable" style="margin-top: 13px !important; cursor:pointer">
                <thead>
                <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                  <th class="">{{ $t('projectTypes.table.order')}}</th>
                  <th class="">{{ $t('projectTypes.table.status')}}</th>
                </tr>
                </thead>
                <Sortable :id="'orderStatusSortable'+id" @change="handleChangeOrder" :processing="ordering">
                  <tr class="draggable" v-for="(stat, index) in statusFormData" :key="index+stat">
                    <td class="draggable-handle"> {{ index+1 }} </td>
                    <td class="draggable-handle"> {{ getStatusTitle(stat) }} </td>
                  </tr>
                </Sortable>

              </table>
            </Card>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" ></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>
import {computed, defineEmits, defineProps, ref, watch} from "vue";
import Button from "@/components/Button.vue"
import RequiredText from "@/components/RequiredText.vue";
import Sortable from "@/components/Sortable.vue";
import Card from "@/components/Card.vue";
import {useStore} from "vuex";

const store = useStore()
const emits = defineEmits(['save'])
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  status: { type: Array, default: () => [] }
})

const statusFormData = ref([...props.status])
const ordering = ref(false)

const taskStatus = computed(() => store.getters['taskStatus/getTaskStatus'])

watch(() => props.status, (val) => {
  if (val && val.length) {
    statusFormData.value = [...val]
  }
})

function handleChangeOrder({ oldIndex, newIndex }) {

  try {
    const status = statusFormData.value
    if (
        oldIndex === newIndex ||
        oldIndex < 0 || oldIndex >= status.length ||
        newIndex < 0 || newIndex > status.length
    ) return;
    ordering.value = true
    const itemToMove = status[oldIndex];
    status.splice(oldIndex, 1);
    status.splice(newIndex, 0, itemToMove);
    statusFormData.value = status
  } finally {
    ordering.value = false
  }


}

function getStatusTitle(id){
  return taskStatus.value?.find(el => el.id === id)?.title
}

function submitForm() {
  emits('save', statusFormData.value)
  closeModal()
}

function closeModal(){
  $('#'+props.id).modal('toggle')
}

</script>

<style scoped>
.icon-wrapper {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper i {
  position: relative;
  font-size: 1.5em;
}

.icon-wrapper .icon-text {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: white;
  margin-top: 8px;
}

.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-left-radius: .625rem !important;
  border-bottom-left-radius: .625rem !important;
}
</style>